import {
    CheckoutAddressForm as SourceCheckoutAddressForm
} from 'SourceComponent/CheckoutAddressForm/CheckoutAddressForm.component';
import transformToNameValuePair from 'Util/Form/Transform';

/** @namespace Bodypwa/Component/CheckoutAddressForm/Component */
export class CheckoutAddressFormComponent extends SourceCheckoutAddressForm {
    // eslint-disable-next-line @scandipwa/scandipwa-guidelines/only-render-in-component
    get fieldMap() {
        const fieldMap = super.fieldMap;
        const { onFormChange } = this;
        const customerDataGroup = fieldMap.find(({ name }) => name === 'customerDataGroup');
        const phoneGroup = fieldMap.find(({ name }) => name === 'phoneGroup');
        const streetGroup = fieldMap.find(({ name }) => name === 'streetGroup');

        if (streetGroup) {
            streetGroup.events = {
                onBlur: onFormChange,
                onLoad: onFormChange
            };
        }
        if (customerDataGroup) {
            customerDataGroup.events = {
                onBlur: onFormChange,
                onLoad: onFormChange
            };
        }
        if (phoneGroup) {
            phoneGroup.events = {
                onBlur: onFormChange,
                onLoad: onFormChange
            };
        }

        return fieldMap;
    }

    onFormChange = (event, data) => {
        const { onCustomerDataFieldsChange } = this.props;
        const newData = [];
        data.fields.map((el) => {
            newData[el.name] = el.value;
            return newData;
        });
        if (newData.street_0) {
            const address = {
                ...newData
            };

            onCustomerDataFieldsChange(address);
        } else {
            onCustomerDataFieldsChange(newData);
        }
    };

    onAddressChange = (event, data) => {
        const { fields = {} } = data;
        const {
            country_id,
            region_id: regionId,
            region_string: region,
            city,
            postcode
        } = transformToNameValuePair(fields);

        const { onShippingEstimationFieldsChange } = this.props;
        const request = {
            country_id,
            region_id: regionId !== '' ? regionId : null,
            region,
            city,
            postcode
        };

        this.onFormChange(event, data);

        // If request hasn't changed, then ignore.
        if (JSON.stringify(request) === JSON.stringify(this.lastRequest)) {
            return;
        }

        onShippingEstimationFieldsChange(request);

        // Caches last request
        this.lastRequest = request;
    };
}

export default CheckoutAddressFormComponent;
